module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.a04b97c3.png";